import React from 'react'
import { Space, Table, Tag } from 'antd'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import styles from './styles.module.css'
import { transactions as vocabulary, translator } from '../../../../../i18n/ru'
import { TransactionListItem } from '../../../../../services/api/transactions'
import { defaultPagination } from '../../../../../services/api/client/types'
import { displayAmount, displayDatetime } from '../../../../../utils/formatter'
import { orderPath } from '../../../../../routes/paths'
import { Link } from 'react-router-dom'
import {
  isCommentable,
  isDebit,
  isLoggable,
  isOrder,
} from '../../../../../utils/types'

type ExtendedTransactionListItem = TransactionListItem & {
  admin?: {
    id: string
    email: string
  }
}
type TableProps = {
  transactions?: ExtendedTransactionListItem[]

  meta?: any
  isLoading: boolean
  onPaginationChange: (page: number, perPage?: number) => void
}
const translate = translator(vocabulary)

export const TransactionsTable: React.FunctionComponent<TableProps> = ({
  transactions,
  meta,
  isLoading,
  onPaginationChange,
}) => {
  return (
    <Table
      dataSource={transactions}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
        },
        {
          title: 'Тип',
          render: (_, transaction) => {
            return isOrder(transaction.reference, transaction.referenceType) ? (
              <Link to={orderPath(transaction.reference.id)}>
                {translate(transaction.referenceType)} №
                {transaction.reference.number}
              </Link>
            ) : (
              translate(transaction.referenceType)
            )
          },
        },
        {
          title: 'Комментарий',
          render: (_, transaction) => {
            return (
              <>
                {isLoggable(transaction.referenceType) && transaction.admin && (
                  <Tag color="blue">{transaction.admin.email}</Tag>
                )}
                {isCommentable(
                  transaction.reference,
                  transaction.referenceType
                ) && (
                  <Tag color="geekblue">{transaction.reference.comment}</Tag>
                )}
              </>
            )
          },
        },
        {
          title: 'Сумма',
          render: (_, transaction) => (
            <Space
              className={
                isDebit(transaction.type)
                  ? styles.transaction_debit
                  : styles.transaction_credit
              }
            >
              {isDebit(transaction.type) ? (
                <PlusCircleOutlined />
              ) : (
                <MinusCircleOutlined />
              )}
              {displayAmount(transaction.amount)}
            </Space>
          ),
        },
        {
          title: 'Дата',
          render: (_, transaction) => displayDatetime(transaction.createdAt),
        },
      ]}
      pagination={{
        onChange: onPaginationChange,
        hideOnSinglePage: true,
        current: meta?.page || defaultPagination.page,
        pageSize: meta?.perPage || defaultPagination.perPage,
        total: meta?.totalCount,
        defaultCurrent: defaultPagination.page,
        defaultPageSize: defaultPagination.perPage,
      }}
      loading={isLoading}
      rowKey={(transaction) => transaction.id}
    />
  )
}
